// extracted by mini-css-extract-plugin
export default {"container":"NotEmpty_container__c60WX","formContainer":"NotEmpty_formContainer__WXuMl","card":"NotEmpty_card__5vb3j"};